module.exports = __webpack_public_path__ + "img/zaixian.60bd3552.png";